import { User } from '../../user/User.interface';
import { FileDto } from '../documents/Document.interface';

export enum TemplateType {
  Capa = 'capa',
  DocumentApproval = 'document-approval',
  // RiskList = 'risk-list',
  // Scar = 'scar',
  // Supplier = 'supplier',
  Trainee = 'trainee',
  // TraineeList = 'trainee-list',
  TrainingPlan = 'training-plan',
  Risk = 'risk',
  ChangeOrder = 'change-order'
}

export const TemplateTypeName: {
  [key in TemplateType]: string;
} = {
  [TemplateType.Capa]: 'CAPA',
  // [TemplateType.RiskList]: 'Risk List',
  [TemplateType.DocumentApproval]: 'Document Approval',
  // [TemplateType.Scar]: 'SCAR',
  // [TemplateType.Supplier]: 'Supplier Evaluation',
  [TemplateType.Trainee]: 'Employee Training Record',
  // [TemplateType.TraineeList]: 'Training Report',
  [TemplateType.TrainingPlan]: 'Training Plan',
  [TemplateType.Risk]: 'Risk',
  [TemplateType.ChangeOrder]: 'Change Order'
};

export interface Template {
  id: number;
  type: TemplateType;
  fileId?: number | null;
  file?: FileDto;
  created: Date;
  modified: Date;
  createdBy: User;
  modifiedBy: User;
}
